import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import Header from '../../common/header'
import Footer from '../../common/footer'
import SvgIcon from '../../common/svg-icon/svg-icon'
import { Breadcrumb } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import RightSideBar from '../../common/rightsidebar'
import { NewInviteUser } from '../../common/newInviteUser';
import axios from 'axios';
import { BASE_URL } from '../../../config/config';
import { formatIsoMilisecondOnlyTime, formatIsoMilisecondsWithoutTime, getDay, formatIsoMiliseconds, replaceSpaceInName, feedTimeAgo, month_names_short } from '../../../common/helperMethods';
import SEO from '../../../components/seo/SEO';
import './index.scss'

import CardBg from '../../../assets/images/new-images/weare-bg.jpg';

const BlogsView = () => {
  const [blogsData, setblogData] = useState([]);
  const history = useHistory();
  const sections = [
    { key: 'Home', content: 'Home', link: true, href: '/' },
    { key: 'blogs', content: 'Articles', link: false },
  ]

  const dropOptions = [
    { key: '1', value: 'Option1', text: 'Option1' },
    { key: '2', value: 'Option2', text: 'Option2' },
    { key: '3', value: 'Option3', text: 'Option3' },
    { key: '4', value: 'Option4', text: 'Option4' },
    { key: '5', value: 'Option5', text: 'Option5' },
    { key: '6', value: 'Option6', text: 'Option6' },
    { key: '7', value: 'Option7', text: 'Option7' },
  ]

  useEffect(() => {

    axios.get(`${BASE_URL}/api/blogs/promotional`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      setblogData(data.rows)

    }).finally(() => {
      //  setLoading(false)
    })
  }, [])

  const gotoArticle = (data) => {
    // history.push(`/feed/post/${data.id}`);
    if (data.type == 'article') {
      history.push(`/article/${replaceSpaceInName(data.title)}/${data.id}`);
    } else {

      history.push(`/feed/post/${data.id}`);
    }
  }
  
  const render_blog_text = (text) => {
    let t = "";
    if(text) {
    t = text.replace(/<\/?[^>]+(>|$)/g, "").substr(0, 250)
    // first word of articleText should be capital 
    t = t.charAt(0).toUpperCase() + t.slice(1);
    }
    return t;
  }

  const render_title = (title) => {
    // first word of article title should be capital 
    if(title) {
      title = title.charAt(0).toUpperCase() + title.slice(1);
    }
    return title;
  }

  return (
    <>
      <SEO key="blogs-seo"
        robots="index, follow"
        canonicalUrl="/articles"
        alternateLink="/articles"
        pageType={'blog'}

      />
      <Header />
      <div className='innerpages-wrapper'>
        <section className='breadcrumb-section'>
          <div className='mappes-container'>
            <Breadcrumb icon={<SvgIcon name='chevron-right' viewbox="0 0 8 14" />} sections={sections} />
          </div>
        </section>
        <section>
          <div className='mappes-container'>
            <div className='innerpages-wrapper-inner locked-post'>
              <div className='innerpages-left-section'>
                <div className='left-fiter-row blogpage-filter-row'>
                  <div className='left-col'>
                    Explore Insights That  <span>Power Advanced Manufacturing</span>
                  </div>
                  {/* <div className='right-col'>
                    <Dropdown icon={<SvgIcon name='chevron-bottom' viewbox="0 0 14 8" />} placeholder='Sort: Popularity' options={dropOptions} />
                    <Dropdown icon={<SvgIcon name='filters' viewbox="0 0 17 17" />} placeholder='Filter' options={dropOptions} />
                  </div> */}
                </div>
                <div className='left-content-row'>
                  {/* Loop Start */}
                  {blogsData.length > 0 && blogsData.map(item => (
                    <div className={`blog-list col${item.id}`} key={item.id}>
                      <div className='blog-list-item ' >
                        <div className='blog-item-upper cursor-pointer' onClick={() => gotoArticle(item)}>
                          <div className='blog-item-left'>
                            <h2>{render_title(item.title)}</h2>
                            <div className='datetime'>{formatIsoMiliseconds(item['@timestamp'])}</div>
                            <p dangerouslySetInnerHTML={{ __html: render_blog_text(item.text) }}></p>
                            {item.text.replace(/<\/?[^>]+(>|$)/g, "").length > 0 && <Link to={`/article/${replaceSpaceInName(item.title)}/${item.id}`}>read more</Link>}

                          </div>
                          <div className='blog-item-right'>
                            <div className='datetime'>{formatIsoMiliseconds(item['@timestamp'])}</div>
                            <div className='blog-img'>
                              {item.media && item.media.image && (
                                <img src={item.media.image.data} alt='' />
                              )}

                            </div>
                          </div>
                        </div>
                        {item.tagged_product_details != undefined && item.tagged_product_details.length > 0 && (
                          <div className='blog-item-bottom'>
                            <div className='tag-list'>
                              {item.tagged_product_details.map(tagged_data => (
                                <Link to={`/product/${replaceSpaceInName(tagged_data.name)}/${tagged_data.id}`} key={tagged_data.id}>{tagged_data.name}</Link>
                              ))}
                            </div>
                          </div>
                        )
                        }
                      </div>
                    </div>
                  ))}
                  {/* Loop end */}

                </div>
              </div>
              <RightSideBar show={'post'} industry={''} />
              <div className='no-readable-overlap'></div>
            </div>
          </div>
        </section>
        <section className='mappessubcribe-section'>
          <div className='mappes-container'>
            <div className='mappessubcribe-card'>
              <img className='mappessubcribe-bg' src={CardBg} alt='' />
              <div className='mappessubcribe-row'>
                <h2 className='text-white'>
                  Turn insight into action.
                  <p className='text-white f-18'>Join Mappes.io to search technologies, connect with suppliers, or share your own expertise.</p>
                </h2>


                <NewInviteUser />
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default BlogsView